import { ROUTE_SIGN_UP_FLOW } from "apps/website/constants/routes";

import { IHeaderLink } from "../../base/Button/Button.map";

const START_MY_TRIAL_TEXT = "Start my trial";

export interface IHeaderAuth {
  firstName: string;
  lastName?: string;
}

export interface IHeaderHistoryNavigation {
  hide?: boolean;
  back?: () => void;
  forward?: () => void;
}

export interface IHeaderLinks {
  primaryLinks: IHeaderLink[];
  secondaryLinks: IHeaderLink[];
  authLinks: IHeaderLink[];
  guestLinks: IHeaderLink[];
}

export const HEADER_LINKS_NONE: IHeaderLinks = {
  primaryLinks: [],
  secondaryLinks: [],
  authLinks: [],
  guestLinks: [],
};

export const HEADER_LINKS_DEFAULT: IHeaderLinks = {
  primaryLinks: [
    {
      id: "p-0",
      name: "Our products",
      to: "/products",
      children: [
        {
          id: "p-0.1",
          name: "Fresh food and treats",
          to: "/products",
          image: {
            src: "/images/dev/components/Header/sub-nav-products-fresh.webp",
            width: 310,
            height: 310,
          },
        },
        {
          id: "p-0.2",
          name: "Scoop planet litter",
          to: "/planet-litter",
          image: {
            src: "/images/dev/components/Header/sub-nav-products-scoop.webp",
            width: 310,
            height: 310,
          },
        },
      ],
    },
    {
      id: "p-1",
      name: "Why fresh",
      to: "/why-fresh",
    },
    { id: "p-2", name: "About us", to: "/about-us" },
    { id: "p-3", name: "Learn", to: "/articles" },
  ],
  secondaryLinks: [],
  authLinks: [
    { id: "a-0", name: "My Homepage", to: "/customer" },
    { id: "a-1", name: "My plans", to: "/customer/my-plans" },
    { id: "a-2", name: "My details", to: "/customer/my-details" },
    { id: "a-3", name: "My cats", to: "/customer/cat-details" },
    { id: "a-4", name: "Free food", to: "/refer-a-friend?situation=hamburger_link" },
    { id: "a-5", name: "Orders", to: "/customer/past-orders" },
    { id: "a-6", name: "Help", to: "https://help.katkin.com/en" },
    { id: "a-7", name: "Logout", to: "#", type: "logout" },
  ],
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: ROUTE_SIGN_UP_FLOW, type: "cta", withAssociatedDiscount: true },
  ],
};
export const HEADER_LINKS_META: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: ROUTE_SIGN_UP_FLOW, type: "cta", withAssociatedDiscount: true },
  ],
};

export const HEADER_LINKS_FRESH_FOOD_NEW_USER: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: ROUTE_SIGN_UP_FLOW, type: "cta", withAssociatedDiscount: true },
  ],
};

export const HEADER_LINKS_FRESH_FEAST_TRIAL: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: ROUTE_SIGN_UP_FLOW, type: "cta" },
  ],
};

export const HEADER_LINKS_FRESH_FEAST_TRIAL_AC: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: `${ROUTE_SIGN_UP_FLOW}?discount_code=MEOWAC30`, type: "cta" },
  ],
};

export const HEADER_LINKS_SIGNUP_FLOW_V2_AC: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: `${ROUTE_SIGN_UP_FLOW}?discount_code=MEOWAC30`, type: "cta" },
  ],
};

export const HEADER_LINKS_SUFV2: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: ROUTE_SIGN_UP_FLOW, type: "cta", withAssociatedDiscount: true },
  ],
};

export const HEADER_LINKS_LOGGED_IN: IHeaderLinks = {
  primaryLinks: [
    { id: "p-0", name: "Home", to: "/customer" },
    { id: "p-1", name: "My Plans", to: "/customer/my-plans" },
    { id: "p-4", name: "My cats", to: "/customer/cat-details" },
    { id: "p-2", name: "My details", to: "/customer/my-details" },
    { id: "p-4", name: "Past orders", to: "/customer/past-orders" },
    { id: "p-6", name: "Learn", to: "/articles" },
  ],
  secondaryLinks: [
    { id: "s-1", name: "Gift a box", to: "/refer-a-friend" },
    { id: "s-2", name: "Help", to: "/help" },
    { id: "s-3", name: "Logout", to: "#", type: "logout" },
  ],
  authLinks: [],
  guestLinks: [],
};

export const HEADER_LINKS_BREEDER: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  authLinks: [
    { id: "a-0", name: "Send a box", to: "/forms/gccf-new-kitten" },
    { id: "a-1", name: "Help", to: "https://faq.katkin.com/" },
    { id: "a-2", name: "Logout", to: "#", type: "logout" },
    { id: "a-3", name: "Send a box", to: "/forms/gccf-new-kitten", type: "cta" },
  ],
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: "Register", to: "/forms/new-breeder", type: "cta" },
  ],
};

export const HEADER_LINKS_SCOOP_PLANET: IHeaderLinks = {
  ...HEADER_LINKS_DEFAULT,
  guestLinks: [
    { id: "g-0", name: "Login", to: "/login" },
    { id: "g-1", name: START_MY_TRIAL_TEXT, to: "/forms/scoop-planet-new-user", type: "cta", withAssociatedDiscount: true },
  ],
};
